// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","button":"card-button_button__DbrCc","investmentOpportunities":"card-button_investmentOpportunities__6+ZT0"};